module.exports = __webpack_public_path__ + "static/media/card-jcb.7c4a94a9.svg";